/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Create a public API to a decorator for the n-th vipr dataset
 *
 * @class DecoratorAPI
 * @hideconstructor
 * @classdesc
 */
define([
	'../DecoratorAPI',
	'../../lib/@waca/dashboard-common/dist/core/APIFactory'
], (DecoratorAPI, APIFactory) => {
	class DecoratorImpl {

		getAPI() {
			return APIFactory.createAPI(this, [DecoratorAPI]);
		}

		/**
		 * Note: Currently, decoratorAPI is a wrapper on the old one.
		 * to use decorator API:
		 *      const oldAPI = this.widget.getDecoratorAPI();  //the legacy api
		 *      const decoratorAPI = APIFactory.createAPI(new Decorator(oldAPI), [DecoratorAPI] );  //wrap it using new api
		 *
		 * @param {} oldDecoratorAPI
		 */
		constructor(oldDecoratorAPI) {
			this._oldDecoratorAPI = oldDecoratorAPI;
		}

		decorateItem(itemIndex, decoration, value) {
			return this._oldDecoratorAPI.decorateItem(itemIndex, decoration, value);
		}


		decoratePoint(rowIndex, decoration, value) {
			return this._oldDecoratorAPI.decoratePoint(rowIndex, decoration, value);
		}


		decorate(decoration, value) {
			return this._oldDecoratorAPI.decorate(decoration, value);
		}


		clearAllItemDecoration(decoration) {
			return this._oldDecoratorAPI.clearAllItemDecoration(decoration);
		}


		renderDecorations() {
			return this._oldDecoratorAPI.updateDecorations();
		}

	}

	return DecoratorImpl;
});
